app.service("BackgroundAPIService", function ($rootScope, toast, ClinicLettersAPI) {
	return {
		sendClinicLetter: function (patientId, clinicLetterId, data, sendHL7 = true) {
			ClinicLettersAPI.completeLetter(patientId, clinicLetterId, data, sendHL7).then(
				function (resp) {
					toast.create({
						timeout: 5 * 1000,
						message: "Clinic Letter is sent",
						className: "alert-success",
						dismissible: true,
					});
				},
				function (error) {
					const serverMessage = error && error.data && error.data.message
						? error.data.message
						: "An unknown server error occurred.";

					toast.create({
						timeout: 10 * 1000,
						message: "<p>CatTrax has encountered an error</p> <p>" + serverMessage + "</p>",
						className: "alert-danger",
						dismissible: true,
					});
				}
			);
		},
		addTemplate: function (data) {
			ClinicLettersAPI.createTemplate(data).then(
				function (resp) {
					toast.create({
						timeout: 5 * 1000,
						message: `template created successfully`,
						className: "alert-success",
						dismissible: true,
					});
				},
				function (error) {
					toast.create({
						timeout: 5 * 1000,
						message: `<p>CatTrax has encountered an error</p> <p>create template Fail</p>`,
						className: "alert-danger",
						dismissible: true,
					});
				}
			);
		},
		saveTemplate: function (templateId,data) {
			ClinicLettersAPI.updateTemplate(templateId, data).then(
				function (resp) {
					toast.create({
						timeout: 5 * 1000,
						message: `template saved successfully`,
						className: "alert-success",
						dismissible: true,
					});
				},
				function (error) {
					toast.create({
						timeout: 5 * 1000,
						message: `<p>CatTrax has encountered an error</p> <p>template saved Fail</p>`,
						className: "alert-danger",
						dismissible: true,
					});
				}
			);
		},
	};
});
